export default __webpack_public_path__ + "static/media/c-info-e.6dfef9cc.svg";